import { USER_RANK_LEVELS } from '@/constants'
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts newline characters in text to HTML <br> tags
 */
export const convertNewlines = (text: string): string => {
  if (!text) return ''
  return text.replace(/\n/g, '<br>')
}

export const detectDeviceType = () => {
  const userAgentInfo = navigator.userAgent
  if (/Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop|BlackBerry/i.test(userAgentInfo))
    return 'mobile'
  else return 'desktop'
}

export const getBrowserName = () => {
  const userAgentInfo = navigator.userAgent

  if (
    /chrome|crios/i.test(userAgentInfo) &&
    !/edg/i.test(userAgentInfo) &&
    !/samsungbrowser/i.test(userAgentInfo)
  ) {
    return 'Chrome'
  } else if (/safari/i.test(userAgentInfo) && !/chrome|crios|edg/i.test(userAgentInfo)) {
    return 'Safari'
  } else {
    return 'Other'
  }
}

export const detectMobileOS = () => {
  const userAgent = window.navigator.userAgent
  // @ts-ignore
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS'
  if (/windows phone/i.test(userAgent)) return 'Windows Phone'
  if (/android/i.test(userAgent)) return 'Android'
}

export const checkFullscreen = () => {
  const deviceType = detectDeviceType()
  const OS = detectMobileOS()
  //@ts-ignore
  if (window.navigator.standalone) return true
  if (deviceType === 'desktop') return true
  else {
    if (OS === 'iOS') return false
    else {
      if (document.fullscreenEnabled) {
        const isFullscreenMode = toggleScreen()
        return !isFullscreenMode
      }
      return false
    }
  }
}

const toggleScreen = async () => {
  if (!document.fullscreenElement) {
    try {
      await document.documentElement.requestFullscreen()
    } catch (e) {
      console.error('toggleScreen error', e)
    }
  } else {
    document.exitFullscreen()
  }
  return document.fullscreenElement
}

export const throttle = <T extends (...args: any[]) => void>(
  fn: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null = null
  const call = (...args: Parameters<T>) => {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => fn(...args), delay)
  }
  return call
}

export const requestAnimationFrameHidden = (fn: () => void) => {
  if (!document.hidden) {
    fn()
    return
  }
  requestAnimationFrame(fn)
}

export const getUserRankData = (
  score: number
): { score: number; rank: number; rankTitle: string; rankMax: number } => {
  const maxScore = USER_RANK_LEVELS[USER_RANK_LEVELS.length - 1].score_range[1]

  if (score > maxScore) {
    score = maxScore
  }

  const rankIndex = USER_RANK_LEVELS.findIndex(
    (level) => score >= level.score_range[0] && score <= level.score_range[1]
  )

  return {
    score: score,
    rank: rankIndex + 1,
    rankTitle: USER_RANK_LEVELS[rankIndex].title,
    rankMax: USER_RANK_LEVELS[rankIndex].score_range[1]
  }
}
